import { buildStoredPalette, readPaletteInputHex } from './color-palette-build.util';
import { parseColorPaletteRaw } from './color-palette-resolve.util';

const COLOR_PALETTE_PARAM_TYPES = ['color_palette', 'colors'] as const;

function isColorPaletteParamType(paramType: string): boolean {
  return (COLOR_PALETTE_PARAM_TYPES as readonly string[]).includes(paramType);
}

function materializeColorPaletteValue(raw: unknown): ReturnType<typeof buildStoredPalette> {
  const parsed = parseColorPaletteRaw(raw);
  return buildStoredPalette(readPaletteInputHex(raw), parsed?.overrides ?? undefined);
}

/**
 * Expands `color_palette` / `colors` params to a full primary+neutral shade map.
 * Compiled live specs often persist `{ input }` only; the webapp needs concrete
 * shades to resolve `$param` refs and to populate `--ui-color-*` CSS variables.
 */
export function materializeColorPaletteParamValues(
  paramValues: Record<string, unknown>,
  paramCatalog: Record<string, { type?: string }>,
): Record<string, unknown> {
  const next = { ...paramValues };

  for (const [key, meta] of Object.entries(paramCatalog)) {
    if (!isColorPaletteParamType(meta.type ?? '')) {
      continue;
    }

    const materialized = materializeColorPaletteValue(next[key]);
    if (materialized) {
      next[key] = materialized;
    }
  }

  return next;
}
